import {VirtualizedSelectOption, VirtualizedSelectOptionsType} from './SelectVirtualized'
import { lineClampStyle } from './VirtualizedConfigData'

export const VirtualizedSelectLoading = () => {
  return (
    <div
      className='d-flex align-items-end justify-content-center p-4 gap-2'
      style={{height: '35px'}}
    >
      <span className='align-text-bottom' style={{lineHeight: '14px'}}>
        Loading
      </span>
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className='spinner-grow spinner-grow-sm'
          role='status'
          style={{height: '4px', width: '4px'}}
        >
          <span className='visually-hidden'>Loading...</span>
        </div>
      ))}
    </div>
  )
}

// --------------- preview selected value component ---------------
export const DefaultSingleValue = ({
  value,
  placeholder,
}: {
  value: VirtualizedSelectOption
  placeholder: string
}) => {
  return (
    <span className='d-flex align-items-center justify-content-start text-truncate w-100 pl-3'>
      {value?.label || placeholder}
    </span>
  )
}

// --------------- default per option component ---------------
export const DefaultOption = ({
  children,
  option,
  onClick,
}: {
  children?: React.ReactNode
  option: VirtualizedSelectOptionsType
  onClick: () => void
}) => (
  <div
    onClick={onClick}
    className='px-3 py-2'
    style={{ ...lineClampStyle(), display: 'block' }}
  >
    {children || option.label}
  </div>
)

// --------------- show selected array isMulti component ---------------
export const ShowMultiValue = ({
  selectedOption,
  handleClose,
}: {
  selectedOption: VirtualizedSelectOption[]
  handleClose: (v: VirtualizedSelectOption) => void
}) => {
  return (
    <>
      {Array.isArray(selectedOption) &&
        selectedOption.map((v) => (
          <div
            key={v.value}
            className='d-flex align-items-center m-0 rounded'
            style={{background: '#e5e5e5', maxWidth: '300px'}}
          >
            <div
              className='border-secondary border-start text-black px-2'
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                maxWidth: '300px',
                fontSize: '11px',
              }}
            >
              {v.label}
            </div>
            <div
              className='d-flex align-items-center h-100 p-2 cursor-pointer'
              onClick={(e) => {
                e.stopPropagation() // Prevent parent onClick event
                handleClose(v)
              }}
            >
              <i className='align-middle bi bi-x-lg' />
            </div>
          </div>
        ))}
    </>
  )
}

// --------------- show group label component ---------------
export const ShowGroupLabel = ({groupList, option}:{groupList:{name:string,color:string}[], option:VirtualizedSelectOptionsType}) => {
  return (
    <div
      className='d-none d-sm-block d-flex align-items-center text-nowrap text-truncate text-white w-auto'
      style={{
        overflowX: 'hidden',
        display: 'block',
        maxWidth: '300px',
        fontSize: '11px',
        borderRadius: '6px',
        padding: '3px 6px',
        background: groupList.find((group) => group.name === option.group)?.color,
      }}
    >
      {option.group}
    </div>
  );
};

